// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as SetupRouteImport } from './routes/setup'
import { Route as SecurityRouteImport } from './routes/security'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as OnboardRouteImport } from './routes/onboard'
import { Route as ModelsRouteImport } from './routes/models'
import { Route as LoginRouteImport } from './routes/login'
import { Route as HelpRouteImport } from './routes/help'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as CliAuthRouteImport } from './routes/cli-auth'
import { Route as BlogRouteImport } from './routes/blog'
import { Route as IndexRouteImport } from './routes/index'
import { Route as InvitationsTokenRouteImport } from './routes/invitations/$token'
import { Route as AdminUsersRouteImport } from './routes/admin/users'
import { Route as AdminFeedbackRouteImport } from './routes/admin/feedback'
import { Route as HelpIndexRouteImport } from './routes/help/index'
import { Route as HelpWorkspaceAccessRouteImport } from './routes/help/workspace-access'
import { Route as HelpWhatIsAgentframerRouteImport } from './routes/help/what-is-agentframer'
import { Route as HelpToolCallPatternsRouteImport } from './routes/help/tool-call-patterns'
import { Route as HelpRolesRouteImport } from './routes/help/roles'
import { Route as HelpQuickStartRouteImport } from './routes/help/quick-start'
import { Route as HelpMcpToolsRouteImport } from './routes/help/mcp-tools'
import { Route as HelpMcpRouteImport } from './routes/help/mcp'
import { Route as HelpInvitingMembersRouteImport } from './routes/help/inviting-members'
import { Route as DashboardIndexRouteImport } from './routes/dashboard/index'
import { Route as DashboardUsageRouteImport } from './routes/dashboard/usage'
import { Route as DashboardSettingsRouteImport } from './routes/dashboard/settings'
import { Route as DashboardNewWorkspaceRouteImport } from './routes/dashboard/new-workspace'
import { Route as DashboardModelsRouteImport } from './routes/dashboard/models'
import { Route as DashboardMembersRouteImport } from './routes/dashboard/members'
import { Route as DashboardHelpRouteImport } from './routes/dashboard/help'
import { Route as DashboardGenerationsRouteImport } from './routes/dashboard/generations'
import { Route as DashboardChatRouteImport } from './routes/dashboard/chat'
import { Route as DashboardBillingRouteImport } from './routes/dashboard/billing'
import { Route as DashboardApiKeysRouteImport } from './routes/dashboard/api-keys'
import { Route as BlogIndexRouteImport } from './routes/blog/index'
import { Route as BlogWhatIsMcpMediaGenerationRouteImport } from './routes/blog/what-is-mcp-media-generation'
import { Route as BlogTextToVideoModelsComparedRouteImport } from './routes/blog/text-to-video-models-compared'
import { Route as BlogSetupMcpCursorImageRouteImport } from './routes/blog/setup-mcp-cursor-image'
import { Route as BlogSetupMcpClaudeDesktopRouteImport } from './routes/blog/setup-mcp-claude-desktop'
import { Route as BlogRunwayAlternativeAgentsRouteImport } from './routes/blog/runway-alternative-agents'
import { Route as BlogOpenSourceImageModels2026RouteImport } from './routes/blog/open-source-image-models-2026'
import { Route as BlogMidjourneyAlternativeMcpRouteImport } from './routes/blog/midjourney-alternative-mcp'
import { Route as BlogMcpVsRestApiMediaRouteImport } from './routes/blog/mcp-vs-rest-api-media'
import { Route as BlogFluxVsSdxlComparisonRouteImport } from './routes/blog/flux-vs-sdxl-comparison'
import { Route as BlogEnterpriseMcpMediaRouteImport } from './routes/blog/enterprise-mcp-media'
import { Route as BlogCostOfAiImageGenerationRouteImport } from './routes/blog/cost-of-ai-image-generation'
import { Route as BlogClaudeCodeImageGenerationRouteImport } from './routes/blog/claude-code-image-generation'
import { Route as BlogAsyncImageGenerationBestPracticesRouteImport } from './routes/blog/async-image-generation-best-practices'
import { Route as BlogAiMusicGenerationForAgentsRouteImport } from './routes/blog/ai-music-generation-for-agents'
import { Route as BlogAiAgentsImageGenerationGuideRouteImport } from './routes/blog/ai-agents-image-generation-guide'
import { Route as BlogAiAgentBatchImageGenerationRouteImport } from './routes/blog/ai-agent-batch-image-generation'
import { Route as BlogAgentVideoGenerationWorkflowRouteImport } from './routes/blog/agent-video-generation-workflow'
import { Route as BlogAgentSoundtrackPipelineRouteImport } from './routes/blog/agent-soundtrack-pipeline'
import { Route as ApiMcpModelsRouteImport } from './routes/api/mcp/models'
import { Route as ApiAuthErrorRouteImport } from './routes/api/auth/error'
import { Route as DashboardHelpIndexRouteImport } from './routes/dashboard/help/index'
import { Route as DashboardHelpWorkspaceAccessRouteImport } from './routes/dashboard/help/workspace-access'
import { Route as DashboardHelpWhatIsAgentframerRouteImport } from './routes/dashboard/help/what-is-agentframer'
import { Route as DashboardHelpToolCallPatternsRouteImport } from './routes/dashboard/help/tool-call-patterns'
import { Route as DashboardHelpRolesRouteImport } from './routes/dashboard/help/roles'
import { Route as DashboardHelpQuickStartRouteImport } from './routes/dashboard/help/quick-start'
import { Route as DashboardHelpMcpToolsRouteImport } from './routes/dashboard/help/mcp-tools'
import { Route as DashboardHelpMcpRouteImport } from './routes/dashboard/help/mcp'
import { Route as DashboardHelpInvitingMembersRouteImport } from './routes/dashboard/help/inviting-members'
import { Route as DashboardWorkspacesWorkspaceSlugSettingsRouteImport } from './routes/dashboard/workspaces/$workspaceSlug/settings'

const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const SignupRoute = SignupRouteImport.update({
            id: '/signup',path: '/signup',getParentRoute: () => rootRouteImport
          })
const SetupRoute = SetupRouteImport.update({
            id: '/setup',path: '/setup',getParentRoute: () => rootRouteImport
          })
const SecurityRoute = SecurityRouteImport.update({
            id: '/security',path: '/security',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const PricingRoute = PricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => rootRouteImport
          })
const OnboardRoute = OnboardRouteImport.update({
            id: '/onboard',path: '/onboard',getParentRoute: () => rootRouteImport
          })
const ModelsRoute = ModelsRouteImport.update({
            id: '/models',path: '/models',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const HelpRoute = HelpRouteImport.update({
            id: '/help',path: '/help',getParentRoute: () => rootRouteImport
          })
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => rootRouteImport
          })
const DashboardRoute = DashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => rootRouteImport
          })
const CliAuthRoute = CliAuthRouteImport.update({
            id: '/cli-auth',path: '/cli-auth',getParentRoute: () => rootRouteImport
          })
const BlogRoute = BlogRouteImport.update({
            id: '/blog',path: '/blog',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const InvitationsTokenRoute = InvitationsTokenRouteImport.update({
            id: '/invitations/$token',path: '/invitations/$token',getParentRoute: () => rootRouteImport
          })
const AdminUsersRoute = AdminUsersRouteImport.update({
            id: '/admin/users',path: '/admin/users',getParentRoute: () => rootRouteImport
          })
const AdminFeedbackRoute = AdminFeedbackRouteImport.update({
            id: '/admin/feedback',path: '/admin/feedback',getParentRoute: () => rootRouteImport
          })
const HelpIndexRoute = HelpIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => HelpRoute
          })
const HelpWorkspaceAccessRoute = HelpWorkspaceAccessRouteImport.update({
            id: '/workspace-access',path: '/workspace-access',getParentRoute: () => HelpRoute
          })
const HelpWhatIsAgentframerRoute = HelpWhatIsAgentframerRouteImport.update({
            id: '/what-is-agentframer',path: '/what-is-agentframer',getParentRoute: () => HelpRoute
          })
const HelpToolCallPatternsRoute = HelpToolCallPatternsRouteImport.update({
            id: '/tool-call-patterns',path: '/tool-call-patterns',getParentRoute: () => HelpRoute
          })
const HelpRolesRoute = HelpRolesRouteImport.update({
            id: '/roles',path: '/roles',getParentRoute: () => HelpRoute
          })
const HelpQuickStartRoute = HelpQuickStartRouteImport.update({
            id: '/quick-start',path: '/quick-start',getParentRoute: () => HelpRoute
          })
const HelpMcpToolsRoute = HelpMcpToolsRouteImport.update({
            id: '/mcp-tools',path: '/mcp-tools',getParentRoute: () => HelpRoute
          })
const HelpMcpRoute = HelpMcpRouteImport.update({
            id: '/mcp',path: '/mcp',getParentRoute: () => HelpRoute
          })
const HelpInvitingMembersRoute = HelpInvitingMembersRouteImport.update({
            id: '/inviting-members',path: '/inviting-members',getParentRoute: () => HelpRoute
          })
const DashboardIndexRoute = DashboardIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DashboardRoute
          })
const DashboardUsageRoute = DashboardUsageRouteImport.update({
            id: '/usage',path: '/usage',getParentRoute: () => DashboardRoute
          })
const DashboardSettingsRoute = DashboardSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => DashboardRoute
          })
const DashboardNewWorkspaceRoute = DashboardNewWorkspaceRouteImport.update({
            id: '/new-workspace',path: '/new-workspace',getParentRoute: () => DashboardRoute
          })
const DashboardModelsRoute = DashboardModelsRouteImport.update({
            id: '/models',path: '/models',getParentRoute: () => DashboardRoute
          })
const DashboardMembersRoute = DashboardMembersRouteImport.update({
            id: '/members',path: '/members',getParentRoute: () => DashboardRoute
          })
const DashboardHelpRoute = DashboardHelpRouteImport.update({
            id: '/help',path: '/help',getParentRoute: () => DashboardRoute
          })
const DashboardGenerationsRoute = DashboardGenerationsRouteImport.update({
            id: '/generations',path: '/generations',getParentRoute: () => DashboardRoute
          })
const DashboardChatRoute = DashboardChatRouteImport.update({
            id: '/chat',path: '/chat',getParentRoute: () => DashboardRoute
          })
const DashboardBillingRoute = DashboardBillingRouteImport.update({
            id: '/billing',path: '/billing',getParentRoute: () => DashboardRoute
          })
const DashboardApiKeysRoute = DashboardApiKeysRouteImport.update({
            id: '/api-keys',path: '/api-keys',getParentRoute: () => DashboardRoute
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => BlogRoute
          })
const BlogWhatIsMcpMediaGenerationRoute = BlogWhatIsMcpMediaGenerationRouteImport.update({
            id: '/what-is-mcp-media-generation',path: '/what-is-mcp-media-generation',getParentRoute: () => BlogRoute
          })
const BlogTextToVideoModelsComparedRoute = BlogTextToVideoModelsComparedRouteImport.update({
            id: '/text-to-video-models-compared',path: '/text-to-video-models-compared',getParentRoute: () => BlogRoute
          })
const BlogSetupMcpCursorImageRoute = BlogSetupMcpCursorImageRouteImport.update({
            id: '/setup-mcp-cursor-image',path: '/setup-mcp-cursor-image',getParentRoute: () => BlogRoute
          })
const BlogSetupMcpClaudeDesktopRoute = BlogSetupMcpClaudeDesktopRouteImport.update({
            id: '/setup-mcp-claude-desktop',path: '/setup-mcp-claude-desktop',getParentRoute: () => BlogRoute
          })
const BlogRunwayAlternativeAgentsRoute = BlogRunwayAlternativeAgentsRouteImport.update({
            id: '/runway-alternative-agents',path: '/runway-alternative-agents',getParentRoute: () => BlogRoute
          })
const BlogOpenSourceImageModels2026Route = BlogOpenSourceImageModels2026RouteImport.update({
            id: '/open-source-image-models-2026',path: '/open-source-image-models-2026',getParentRoute: () => BlogRoute
          })
const BlogMidjourneyAlternativeMcpRoute = BlogMidjourneyAlternativeMcpRouteImport.update({
            id: '/midjourney-alternative-mcp',path: '/midjourney-alternative-mcp',getParentRoute: () => BlogRoute
          })
const BlogMcpVsRestApiMediaRoute = BlogMcpVsRestApiMediaRouteImport.update({
            id: '/mcp-vs-rest-api-media',path: '/mcp-vs-rest-api-media',getParentRoute: () => BlogRoute
          })
const BlogFluxVsSdxlComparisonRoute = BlogFluxVsSdxlComparisonRouteImport.update({
            id: '/flux-vs-sdxl-comparison',path: '/flux-vs-sdxl-comparison',getParentRoute: () => BlogRoute
          })
const BlogEnterpriseMcpMediaRoute = BlogEnterpriseMcpMediaRouteImport.update({
            id: '/enterprise-mcp-media',path: '/enterprise-mcp-media',getParentRoute: () => BlogRoute
          })
const BlogCostOfAiImageGenerationRoute = BlogCostOfAiImageGenerationRouteImport.update({
            id: '/cost-of-ai-image-generation',path: '/cost-of-ai-image-generation',getParentRoute: () => BlogRoute
          })
const BlogClaudeCodeImageGenerationRoute = BlogClaudeCodeImageGenerationRouteImport.update({
            id: '/claude-code-image-generation',path: '/claude-code-image-generation',getParentRoute: () => BlogRoute
          })
const BlogAsyncImageGenerationBestPracticesRoute = BlogAsyncImageGenerationBestPracticesRouteImport.update({
            id: '/async-image-generation-best-practices',path: '/async-image-generation-best-practices',getParentRoute: () => BlogRoute
          })
const BlogAiMusicGenerationForAgentsRoute = BlogAiMusicGenerationForAgentsRouteImport.update({
            id: '/ai-music-generation-for-agents',path: '/ai-music-generation-for-agents',getParentRoute: () => BlogRoute
          })
const BlogAiAgentsImageGenerationGuideRoute = BlogAiAgentsImageGenerationGuideRouteImport.update({
            id: '/ai-agents-image-generation-guide',path: '/ai-agents-image-generation-guide',getParentRoute: () => BlogRoute
          })
const BlogAiAgentBatchImageGenerationRoute = BlogAiAgentBatchImageGenerationRouteImport.update({
            id: '/ai-agent-batch-image-generation',path: '/ai-agent-batch-image-generation',getParentRoute: () => BlogRoute
          })
const BlogAgentVideoGenerationWorkflowRoute = BlogAgentVideoGenerationWorkflowRouteImport.update({
            id: '/agent-video-generation-workflow',path: '/agent-video-generation-workflow',getParentRoute: () => BlogRoute
          })
const BlogAgentSoundtrackPipelineRoute = BlogAgentSoundtrackPipelineRouteImport.update({
            id: '/agent-soundtrack-pipeline',path: '/agent-soundtrack-pipeline',getParentRoute: () => BlogRoute
          })
const ApiMcpModelsRoute = ApiMcpModelsRouteImport.update({
            id: '/api/mcp/models',path: '/api/mcp/models',getParentRoute: () => rootRouteImport
          })
const ApiAuthErrorRoute = ApiAuthErrorRouteImport.update({
            id: '/api/auth/error',path: '/api/auth/error',getParentRoute: () => rootRouteImport
          })
const DashboardHelpIndexRoute = DashboardHelpIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DashboardHelpRoute
          })
const DashboardHelpWorkspaceAccessRoute = DashboardHelpWorkspaceAccessRouteImport.update({
            id: '/workspace-access',path: '/workspace-access',getParentRoute: () => DashboardHelpRoute
          })
const DashboardHelpWhatIsAgentframerRoute = DashboardHelpWhatIsAgentframerRouteImport.update({
            id: '/what-is-agentframer',path: '/what-is-agentframer',getParentRoute: () => DashboardHelpRoute
          })
const DashboardHelpToolCallPatternsRoute = DashboardHelpToolCallPatternsRouteImport.update({
            id: '/tool-call-patterns',path: '/tool-call-patterns',getParentRoute: () => DashboardHelpRoute
          })
const DashboardHelpRolesRoute = DashboardHelpRolesRouteImport.update({
            id: '/roles',path: '/roles',getParentRoute: () => DashboardHelpRoute
          })
const DashboardHelpQuickStartRoute = DashboardHelpQuickStartRouteImport.update({
            id: '/quick-start',path: '/quick-start',getParentRoute: () => DashboardHelpRoute
          })
const DashboardHelpMcpToolsRoute = DashboardHelpMcpToolsRouteImport.update({
            id: '/mcp-tools',path: '/mcp-tools',getParentRoute: () => DashboardHelpRoute
          })
const DashboardHelpMcpRoute = DashboardHelpMcpRouteImport.update({
            id: '/mcp',path: '/mcp',getParentRoute: () => DashboardHelpRoute
          })
const DashboardHelpInvitingMembersRoute = DashboardHelpInvitingMembersRouteImport.update({
            id: '/inviting-members',path: '/inviting-members',getParentRoute: () => DashboardHelpRoute
          })
const DashboardWorkspacesWorkspaceSlugSettingsRoute = DashboardWorkspacesWorkspaceSlugSettingsRouteImport.update({
            id: '/workspaces/$workspaceSlug/settings',path: '/workspaces/$workspaceSlug/settings',getParentRoute: () => DashboardRoute
          })





const BlogRouteChildren = {
  BlogAgentSoundtrackPipelineRoute: BlogAgentSoundtrackPipelineRoute,BlogAgentVideoGenerationWorkflowRoute: BlogAgentVideoGenerationWorkflowRoute,BlogAiAgentBatchImageGenerationRoute: BlogAiAgentBatchImageGenerationRoute,BlogAiAgentsImageGenerationGuideRoute: BlogAiAgentsImageGenerationGuideRoute,BlogAiMusicGenerationForAgentsRoute: BlogAiMusicGenerationForAgentsRoute,BlogAsyncImageGenerationBestPracticesRoute: BlogAsyncImageGenerationBestPracticesRoute,BlogClaudeCodeImageGenerationRoute: BlogClaudeCodeImageGenerationRoute,BlogCostOfAiImageGenerationRoute: BlogCostOfAiImageGenerationRoute,BlogEnterpriseMcpMediaRoute: BlogEnterpriseMcpMediaRoute,BlogFluxVsSdxlComparisonRoute: BlogFluxVsSdxlComparisonRoute,BlogMcpVsRestApiMediaRoute: BlogMcpVsRestApiMediaRoute,BlogMidjourneyAlternativeMcpRoute: BlogMidjourneyAlternativeMcpRoute,BlogOpenSourceImageModels2026Route: BlogOpenSourceImageModels2026Route,BlogRunwayAlternativeAgentsRoute: BlogRunwayAlternativeAgentsRoute,BlogSetupMcpClaudeDesktopRoute: BlogSetupMcpClaudeDesktopRoute,BlogSetupMcpCursorImageRoute: BlogSetupMcpCursorImageRoute,BlogTextToVideoModelsComparedRoute: BlogTextToVideoModelsComparedRoute,BlogWhatIsMcpMediaGenerationRoute: BlogWhatIsMcpMediaGenerationRoute,BlogIndexRoute: BlogIndexRoute
}

const BlogRouteWithChildren = BlogRoute._addFileChildren(BlogRouteChildren)




const DashboardHelpRouteChildren = {
  DashboardHelpInvitingMembersRoute: DashboardHelpInvitingMembersRoute,DashboardHelpMcpRoute: DashboardHelpMcpRoute,DashboardHelpMcpToolsRoute: DashboardHelpMcpToolsRoute,DashboardHelpQuickStartRoute: DashboardHelpQuickStartRoute,DashboardHelpRolesRoute: DashboardHelpRolesRoute,DashboardHelpToolCallPatternsRoute: DashboardHelpToolCallPatternsRoute,DashboardHelpWhatIsAgentframerRoute: DashboardHelpWhatIsAgentframerRoute,DashboardHelpWorkspaceAccessRoute: DashboardHelpWorkspaceAccessRoute,DashboardHelpIndexRoute: DashboardHelpIndexRoute
}

const DashboardHelpRouteWithChildren = DashboardHelpRoute._addFileChildren(DashboardHelpRouteChildren)



const DashboardRouteChildren = {
  DashboardApiKeysRoute: DashboardApiKeysRoute,DashboardBillingRoute: DashboardBillingRoute,DashboardChatRoute: DashboardChatRoute,DashboardGenerationsRoute: DashboardGenerationsRoute,DashboardHelpRoute: DashboardHelpRouteWithChildren,DashboardMembersRoute: DashboardMembersRoute,DashboardModelsRoute: DashboardModelsRoute,DashboardNewWorkspaceRoute: DashboardNewWorkspaceRoute,DashboardSettingsRoute: DashboardSettingsRoute,DashboardUsageRoute: DashboardUsageRoute,DashboardIndexRoute: DashboardIndexRoute,DashboardWorkspacesWorkspaceSlugSettingsRoute: DashboardWorkspacesWorkspaceSlugSettingsRoute
}

const DashboardRouteWithChildren = DashboardRoute._addFileChildren(DashboardRouteChildren)




const HelpRouteChildren = {
  HelpInvitingMembersRoute: HelpInvitingMembersRoute,HelpMcpRoute: HelpMcpRoute,HelpMcpToolsRoute: HelpMcpToolsRoute,HelpQuickStartRoute: HelpQuickStartRoute,HelpRolesRoute: HelpRolesRoute,HelpToolCallPatternsRoute: HelpToolCallPatternsRoute,HelpWhatIsAgentframerRoute: HelpWhatIsAgentframerRoute,HelpWorkspaceAccessRoute: HelpWorkspaceAccessRoute,HelpIndexRoute: HelpIndexRoute
}

const HelpRouteWithChildren = HelpRoute._addFileChildren(HelpRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,BlogRoute: BlogRouteWithChildren,CliAuthRoute: CliAuthRoute,DashboardRoute: DashboardRouteWithChildren,ForgotPasswordRoute: ForgotPasswordRoute,HelpRoute: HelpRouteWithChildren,LoginRoute: LoginRoute,ModelsRoute: ModelsRoute,OnboardRoute: OnboardRoute,PricingRoute: PricingRoute,PrivacyRoute: PrivacyRoute,ResetPasswordRoute: ResetPasswordRoute,SecurityRoute: SecurityRoute,SetupRoute: SetupRoute,SignupRoute: SignupRoute,TermsRoute: TermsRoute,AdminFeedbackRoute: AdminFeedbackRoute,AdminUsersRoute: AdminUsersRoute,InvitationsTokenRoute: InvitationsTokenRoute,ApiAuthErrorRoute: ApiAuthErrorRoute,ApiMcpModelsRoute: ApiMcpModelsRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)